var cov_2c1pfejx30 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/css-accessors.ts",
      hash = "ba928dcbfe8bb78ffe4575f0340a357f06a759cc",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/css-accessors.ts",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 10,
          column: 22
        }
      },
      "1": {
        start: {
          line: 10,
          column: 16
        },
        end: {
          line: 10,
          column: 22
        }
      },
      "2": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 14,
          column: 3
        }
      },
      "3": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 32
        }
      },
      "4": {
        start: {
          line: 12,
          column: 24
        },
        end: {
          line: 12,
          column: 32
        }
      },
      "5": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 13,
          column: 21
        }
      },
      "6": {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 18,
          column: 32
        }
      },
      "7": {
        start: {
          line: 19,
          column: 16
        },
        end: {
          line: 19,
          column: 44
        }
      },
      "8": {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 22,
          column: 4
        }
      },
      "9": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 61
        }
      },
      "10": {
        start: {
          line: 21,
          column: 27
        },
        end: {
          line: 21,
          column: 61
        }
      },
      "11": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 23,
          column: 14
        }
      },
      "12": {
        start: {
          line: 27,
          column: 14
        },
        end: {
          line: 27,
          column: 43
        }
      },
      "13": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 28,
          column: 27
        }
      },
      "14": {
        start: {
          line: 29,
          column: 2
        },
        end: {
          line: 29,
          column: 39
        }
      },
      "15": {
        start: {
          line: 32,
          column: 25
        },
        end: {
          line: 32,
          column: 27
        }
      },
      "16": {
        start: {
          line: 43,
          column: 2
        },
        end: {
          line: 63,
          column: 4
        }
      },
      "17": {
        start: {
          line: 44,
          column: 62
        },
        end: {
          line: 44,
          column: 66
        }
      },
      "18": {
        start: {
          line: 44,
          column: 56
        },
        end: {
          line: 44,
          column: 57
        }
      },
      "19": {
        start: {
          line: 45,
          column: 21
        },
        end: {
          line: 45,
          column: 25
        }
      },
      "20": {
        start: {
          line: 46,
          column: 21
        },
        end: {
          line: 46,
          column: 43
        }
      },
      "21": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 62,
          column: 6
        }
      },
      "22": {
        start: {
          line: 50,
          column: 8
        },
        end: {
          line: 50,
          column: 51
        }
      },
      "23": {
        start: {
          line: 50,
          column: 29
        },
        end: {
          line: 50,
          column: 51
        }
      },
      "24": {
        start: {
          line: 51,
          column: 8
        },
        end: {
          line: 51,
          column: 41
        }
      },
      "25": {
        start: {
          line: 51,
          column: 24
        },
        end: {
          line: 51,
          column: 41
        }
      },
      "26": {
        start: {
          line: 52,
          column: 20
        },
        end: {
          line: 52,
          column: 49
        }
      },
      "27": {
        start: {
          line: 53,
          column: 8
        },
        end: {
          line: 53,
          column: 37
        }
      },
      "28": {
        start: {
          line: 54,
          column: 8
        },
        end: {
          line: 54,
          column: 30
        }
      },
      "29": {
        start: {
          line: 58,
          column: 8
        },
        end: {
          line: 58,
          column: 30
        }
      },
      "30": {
        start: {
          line: 59,
          column: 8
        },
        end: {
          line: 59,
          column: 38
        }
      },
      "31": {
        start: {
          line: 59,
          column: 24
        },
        end: {
          line: 59,
          column: 38
        }
      },
      "32": {
        start: {
          line: 60,
          column: 8
        },
        end: {
          line: 60,
          column: 22
        }
      },
      "33": {
        start: {
          line: 66,
          column: 18
        },
        end: {
          line: 66,
          column: 103
        }
      },
      "34": {
        start: {
          line: 66,
          column: 63
        },
        end: {
          line: 66,
          column: 84
        }
      },
      "35": {
        start: {
          line: 68,
          column: 0
        },
        end: {
          line: 72,
          column: 1
        }
      },
      "36": {
        start: {
          line: 69,
          column: 21
        },
        end: {
          line: 69,
          column: 44
        }
      },
      "37": {
        start: {
          line: 70,
          column: 2
        },
        end: {
          line: 70,
          column: 83
        }
      },
      "38": {
        start: {
          line: 70,
          column: 40
        },
        end: {
          line: 70,
          column: 83
        }
      },
      "39": {
        start: {
          line: 71,
          column: 2
        },
        end: {
          line: 71,
          column: 63
        }
      },
      "40": {
        start: {
          line: 75,
          column: 2
        },
        end: {
          line: 75,
          column: 12
        }
      }
    },
    fnMap: {
      "0": {
        name: "setOptions",
        decl: {
          start: {
            line: 9,
            column: 9
          },
          end: {
            line: 9,
            column: 19
          }
        },
        loc: {
          start: {
            line: 9,
            column: 47
          },
          end: {
            line: 15,
            column: 1
          }
        },
        line: 9
      },
      "1": {
        name: "getDOMStyle",
        decl: {
          start: {
            line: 17,
            column: 9
          },
          end: {
            line: 17,
            column: 20
          }
        },
        loc: {
          start: {
            line: 17,
            column: 39
          },
          end: {
            line: 24,
            column: 1
          }
        },
        line: 17
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 20,
            column: 25
          },
          end: {
            line: 20,
            column: 26
          }
        },
        loc: {
          start: {
            line: 20,
            column: 31
          },
          end: {
            line: 22,
            column: 3
          }
        },
        line: 20
      },
      "3": {
        name: "getStyleAttr",
        decl: {
          start: {
            line: 26,
            column: 9
          },
          end: {
            line: 26,
            column: 21
          }
        },
        loc: {
          start: {
            line: 26,
            column: 83
          },
          end: {
            line: 30,
            column: 1
          }
        },
        line: 26
      },
      "4": {
        name: "genAccessors",
        decl: {
          start: {
            line: 42,
            column: 9
          },
          end: {
            line: 42,
            column: 21
          }
        },
        loc: {
          start: {
            line: 42,
            column: 54
          },
          end: {
            line: 64,
            column: 1
          }
        },
        line: 42
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 43,
            column: 20
          },
          end: {
            line: 43,
            column: 21
          }
        },
        loc: {
          start: {
            line: 43,
            column: 36
          },
          end: {
            line: 63,
            column: 3
          }
        },
        line: 43
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 44,
            column: 44
          },
          end: {
            line: 44,
            column: 45
          }
        },
        loc: {
          start: {
            line: 44,
            column: 56
          },
          end: {
            line: 44,
            column: 57
          }
        },
        line: 44
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 49,
            column: 11
          },
          end: {
            line: 49,
            column: 12
          }
        },
        loc: {
          start: {
            line: 49,
            column: 17
          },
          end: {
            line: 55,
            column: 7
          }
        },
        line: 49
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 57,
            column: 11
          },
          end: {
            line: 57,
            column: 12
          }
        },
        loc: {
          start: {
            line: 57,
            column: 16
          },
          end: {
            line: 61,
            column: 7
          }
        },
        line: 57
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 66,
            column: 48
          },
          end: {
            line: 66,
            column: 49
          }
        },
        loc: {
          start: {
            line: 66,
            column: 63
          },
          end: {
            line: 66,
            column: 84
          }
        },
        line: 66
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 70,
            column: 22
          },
          end: {
            line: 70,
            column: 23
          }
        },
        loc: {
          start: {
            line: 70,
            column: 40
          },
          end: {
            line: 70,
            column: 83
          }
        },
        line: 70
      },
      "11": {
        name: "cleanCache",
        decl: {
          start: {
            line: 74,
            column: 16
          },
          end: {
            line: 74,
            column: 26
          }
        },
        loc: {
          start: {
            line: 74,
            column: 29
          },
          end: {
            line: 76,
            column: 1
          }
        },
        line: 74
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 22
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 22
          }
        }, {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 22
          }
        }],
        line: 10
      },
      "1": {
        loc: {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 12,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 12,
            column: 32
          }
        }, {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 12,
            column: 32
          }
        }],
        line: 12
      },
      "2": {
        loc: {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 21,
            column: 61
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 21,
            column: 61
          }
        }, {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 21,
            column: 61
          }
        }],
        line: 21
      },
      "3": {
        loc: {
          start: {
            line: 26,
            column: 41
          },
          end: {
            line: 26,
            column: 81
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 26,
            column: 74
          },
          end: {
            line: 26,
            column: 81
          }
        }],
        line: 26
      },
      "4": {
        loc: {
          start: {
            line: 44,
            column: 35
          },
          end: {
            line: 44,
            column: 57
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 44,
            column: 44
          },
          end: {
            line: 44,
            column: 57
          }
        }],
        line: 44
      },
      "5": {
        loc: {
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 50,
            column: 51
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 50,
            column: 51
          }
        }, {
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 50,
            column: 51
          }
        }],
        line: 50
      },
      "6": {
        loc: {
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 51,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 51,
            column: 41
          }
        }, {
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 51,
            column: 41
          }
        }],
        line: 51
      },
      "7": {
        loc: {
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 59,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 59,
            column: 38
          }
        }, {
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 59,
            column: 38
          }
        }],
        line: 59
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0],
      "4": [0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _defineProperty from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread2 from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import cssInject from './vars-inject';
import { capitalize } from './strings';
import { entries } from './objects';

function setOptions(options, setter) {
  cov_2c1pfejx30.f[0]++;
  cov_2c1pfejx30.s[0]++;

  if (!options) {
    cov_2c1pfejx30.b[0][0]++;
    cov_2c1pfejx30.s[1]++;
    return;
  } else {
    cov_2c1pfejx30.b[0][1]++;
  }

  cov_2c1pfejx30.s[2]++;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = entries(options)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          _value = _step$value[1];

      cov_2c1pfejx30.s[3]++;

      if (key === setter) {
        cov_2c1pfejx30.b[1][0]++;
        cov_2c1pfejx30.s[4]++;
        continue;
      } else {
        cov_2c1pfejx30.b[1][1]++;
      }

      cov_2c1pfejx30.s[5]++;
      this[key] = _value;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function getDOMStyle(dom) {
  cov_2c1pfejx30.f[1]++;
  cov_2c1pfejx30.s[6]++;
  document.body.appendChild(dom);
  var style = (cov_2c1pfejx30.s[7]++, window.getComputedStyle(dom));
  cov_2c1pfejx30.s[8]++;
  Promise.resolve().then(function () {
    cov_2c1pfejx30.f[2]++;
    cov_2c1pfejx30.s[9]++;

    if (dom.parentElement) {
      cov_2c1pfejx30.b[2][0]++;
      cov_2c1pfejx30.s[10]++;
      dom.parentElement.removeChild(dom);
    } else {
      cov_2c1pfejx30.b[2][1]++;
    }
  });
  cov_2c1pfejx30.s[11]++;
  return style;
}

function getStyleAttr(className) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_2c1pfejx30.b[3][0]++, 'color');
  cov_2c1pfejx30.f[3]++;
  var div = (cov_2c1pfejx30.s[12]++, document.createElement('div'));
  cov_2c1pfejx30.s[13]++;
  div.className = className;
  cov_2c1pfejx30.s[14]++;
  return getDOMStyle(div)[key];
}

var cache = (cov_2c1pfejx30.s[15]++, {});

function genAccessors(obj, data) {
  cov_2c1pfejx30.f[4]++;
  cov_2c1pfejx30.s[16]++;
  data.conf.forEach(function (item) {
    cov_2c1pfejx30.f[5]++;

    var _ref = (cov_2c1pfejx30.s[17]++, item),
        name = _ref.name,
        className = _ref.className,
        attr = _ref.attr,
        _ref$parser = _ref.parser,
        parser = _ref$parser === void 0 ? (cov_2c1pfejx30.b[4][0]++, function (v) {
      cov_2c1pfejx30.f[6]++;
      cov_2c1pfejx30.s[18]++;
      return v;
    }) : _ref$parser;

    var _ref2 = (cov_2c1pfejx30.s[19]++, data),
        info = _ref2.info;

    var cacheKey = (cov_2c1pfejx30.s[20]++, "".concat(info.name, "-").concat(name));
    cov_2c1pfejx30.s[21]++;
    Object.defineProperty(obj, name, {
      enumerable: true,
      get: function get() {
        cov_2c1pfejx30.f[7]++;
        cov_2c1pfejx30.s[22]++;

        if (cache[cacheKey]) {
          cov_2c1pfejx30.b[5][0]++;
          cov_2c1pfejx30.s[23]++;
          return cache[cacheKey];
        } else {
          cov_2c1pfejx30.b[5][1]++;
        }

        cov_2c1pfejx30.s[24]++;

        if (item.value) {
          cov_2c1pfejx30.b[6][0]++;
          cov_2c1pfejx30.s[25]++;
          return item.value;
        } else {
          cov_2c1pfejx30.b[6][1]++;
        }

        var res = (cov_2c1pfejx30.s[26]++, getStyleAttr(className, attr));
        cov_2c1pfejx30.s[27]++;
        cache[cacheKey] = parser(res);
        cov_2c1pfejx30.s[28]++;
        return cache[cacheKey];
      },
      // eslint-disable-next-line no-return-assign
      set: function set(v) {
        cov_2c1pfejx30.f[8]++;
        cov_2c1pfejx30.s[29]++;
        delete cache[cacheKey];
        cov_2c1pfejx30.s[30]++;

        if (item.value) {
          cov_2c1pfejx30.b[7][0]++;
          cov_2c1pfejx30.s[31]++;
          item.value = v;
        } else {
          cov_2c1pfejx30.b[7][1]++;
        }

        cov_2c1pfejx30.s[32]++;
        data[name] = v;
      }
    });
  });
}

var accessors = (cov_2c1pfejx30.s[33]++, Object.keys(cssInject).reduce(function (obj, key) {
  cov_2c1pfejx30.f[9]++;
  cov_2c1pfejx30.s[34]++;
  return _objectSpread2(_objectSpread2({}, obj), {}, _defineProperty({}, key, {}));
}, {}));
cov_2c1pfejx30.s[35]++;
var _iteratorNormalCompletion2 = true;
var _didIteratorError2 = false;
var _iteratorError2 = undefined;

try {
  var _loop = function _loop() {
    var _step2$value = _slicedToArray(_step2.value, 2),
        key = _step2$value[0],
        value = _step2$value[1];

    var setterName = (cov_2c1pfejx30.s[36]++, "set".concat(capitalize(key)));
    cov_2c1pfejx30.s[37]++;

    value[setterName] = function (options) {
      cov_2c1pfejx30.f[10]++;
      cov_2c1pfejx30.s[38]++;
      return setOptions.call(value, options, setterName);
    };

    cov_2c1pfejx30.s[39]++;
    genAccessors(value, cssInject[key]);
  };

  for (var _iterator2 = entries(accessors)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
    _loop();
  }
} catch (err) {
  _didIteratorError2 = true;
  _iteratorError2 = err;
} finally {
  try {
    if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
      _iterator2["return"]();
    }
  } finally {
    if (_didIteratorError2) {
      throw _iteratorError2;
    }
  }
}

export function cleanCache() {
  cov_2c1pfejx30.f[11]++;
  cov_2c1pfejx30.s[40]++;
  cache = {};
}
export default accessors;